// @ts-nocheck
import * as TYPES from '../types';

const initialState = {
    visible: false,
    filters: {},
};

const savedFilters = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case TYPES.SAVED_FILTERS_CHANGED: {
            return {
                ...state,
                filters: {
                    ...state.filters,
                    [payload.key]: payload.filters,
                },
            };
        }
        case TYPES.SAVED_FILTERS_DRAWER_VISIBILITY: {
            return {
                ...state,
                visible: payload,
            };
        }
        default:
            return state;
    }
};

export default savedFilters;
